import Body from "./Body";
import AdminInfo from "../../../components/PagesComponents/Setting/Profile/AdminInfo.component";
import BasicInfo from "../../../components/PagesComponents/Setting/Profile/BasicInfo.component";
import AdvanceInfo from "../../../components/PagesComponents/Setting/Profile/AdvanceInfo.component";
import DocumentInfo from "../../../components/PagesComponents/Setting/Profile/DocumentInfo.component";
import SettingStore from "../../../store/Setting/Setting.store";
import { ReactComponent as BasicInfoIcon } from "../../../assets/Icons/Setting/Profile/BasicInfo.svg";
import { ReactComponent as AdvanceInfoIcon } from "../../../assets/Icons/Setting/Profile/AdvanceInfo.svg";
import { ReactComponent as DocumentInfoIcon } from "../../../assets/Icons/Setting/Profile/DocumentInfo.svg";
import { useEffect, useState } from "react";
import signImage from "../../../assets/Images/TestImg/Signature.png";

const Profile = () => {
  const { currentTab, setCurrentTab } = SettingStore(); //admininfo,basicinfo,advanceinfo,documentinfo
  // eslint-disable-next-line no-unused-vars
  const [adminInfo, setAdminInfo] = useState({
    gender: "Male",
    profileImage: "https://randomuser.me/api/portraits/men/75.jpg", // or use actual source
    id: "30223893452",
    signature: signImage, // replace with actual signature image
    name: "Kalim Hossain",
    email: "abc@gmail.com",
    joiningDate: "2 November, 2024",
    workingField: "Management",
    reportingTo: "Supreme",
    experience: "1-2 Years",
    address: "Gobindapur, Birsingah, North 24 Parganas",
    phone: "9876543210",
    designation: "President",
    relationship: "Unmarried",
    salary: "30000",
    bloodGroup: "B+",
    experienceField: "Social work",
    aadhaarNumber: "123456789012",
    aadhaarVerified: true,
    positionColor: "#F498C6", // default or chosen color
  });

  const handelCurrentTab = () => {
    //logic for tab switching admininfo,basicinfo,advanceinfo,documentinfo
    if (currentTab === "admininfo") {
      return <AdminInfo data={adminInfo} setCurrentTab={setCurrentTab} />;
    } else if (currentTab === "basicinfo") {
      return <BasicInfo data={""} setCurrentTab={setCurrentTab} />;
    } else if (currentTab === "advanceinfo") {
      return <AdvanceInfo data={""} setCurrentTab={setCurrentTab} />;
    } else if (currentTab === "documentinfo") {
      return <DocumentInfo data={""} setCurrentTab={setCurrentTab} />;
    } else {
      return "invalid Path";
    }
  };
  const pathNames = ["admininfo", "basicinfo", "advanceinfo", "documentinfo"];
  useEffect(() => {
    if (!pathNames.includes(currentTab.toString().toLowerCase())) {
      setCurrentTab("admininfo");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setCurrentTab]);
  const intituteIcons = {
    Basic: (
      <BasicInfoIcon
        className={
          currentTab === "basicinfo" ? "activeSettingPathChangerBtnIcon" : ""
        }
      />
    ),
    Advance: (
      <AdvanceInfoIcon
        className={
          currentTab === "advanceinfo" ? "activeSettingPathChangerBtnIcon" : ""
        }
      />
    ),
    Document: (
      <DocumentInfoIcon
        className={
          currentTab === "documentinfo" ? "activeSettingPathChangerBtnIcon" : ""
        }
      />
    ),
  };

  const institutePathName = {
    Basic: "basicinfo",
    Advance: "advanceinfo",
    Document: "documentinfo",
  };
  const [institutePaths, setIntitutePaths] = useState([
    "Basic",
    "Advance",
    "Document",
  ]);

  const _this = {
    currentTab,
    setCurrentTab,
    handelCurrentTab,
    intituteIcons,
    institutePathName,
    institutePaths,
    setIntitutePaths,
  };
  return <Body {..._this} />;
};

export default Profile;
